var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "nudge-fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "nudge-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nudge-box",
    attrs: {
      "role": "alert",
      "aria-live": "assertive"
    }
  }, [_c('div', {
    staticClass: "nudge-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('p', {
    staticClass: "nudge-text"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    staticClass: "nudge-close",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("OK")])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-318bef3b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NudgeMessage.vue
// module id = 515
// module chunks = 2